import type { SVGProps } from 'react';

const SvgSurveys = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M29 .13H3A2.73 2.73 0 0 0 .29 2.86v26.28A2.73 2.73 0 0 0 3 31.87h26a2.72 2.72 0 0 0 2.72-2.73V2.86A2.72 2.72 0 0 0 29 .13m1.22 29A1.23 1.23 0 0 1 29 30.37H3a1.23 1.23 0 0 1-1.23-1.23V2.86A1.23 1.23 0 0 1 3 1.63h26a1.23 1.23 0 0 1 1.22 1.23Z" />
      <path d="M9.9 9.89 8.13 8.12 7.07 9.18l2.3 2.3a.74.74 0 0 0 .53.22.73.73 0 0 0 .53-.22L17 4.9l-1-1.06Z" />
      <path d="M14.36 12.92a.52.52 0 0 1-.52.52H6.65a.52.52 0 0 1-.52-.52v-7a.52.52 0 0 1 .52-.52h5.71V3.89H6.65a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7.19a2 2 0 0 0 2-2V9.42h-1.5ZM13.84 17.33H6.65a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7.19a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2m.52 9a.52.52 0 0 1-.52.52H6.65a.52.52 0 0 1-.52-.52v-7a.51.51 0 0 1 .52-.51h7.19a.51.51 0 0 1 .52.51ZM18.51 8.67h9.11v1.5h-9.11zM18.51 22.1h9.11v1.5h-9.11z" />
    </g>
  </svg>
);

export default SvgSurveys;
